// initial state
const state = {
    locale: 'es-ES',
    currency: 'EUR'
}

// getters
const getters = {
    getLocale: (state, getters, rootState) => {
        return state.locale || 'es-ES'
    },
    getCurrency: (state, getters, rootState) => {
        return state.currency
    }
}

// actions
const actions = {
   
}

// mutations
const mutations = {
    setLocale(state, locale) {
        state.locale = (locale && String(locale).trim()) ? locale : 'es-ES'
    },
    setCurrency(state, currency) {
        state.currency = currency
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
